//@ts-nocheck

import {Button} from '_core'
import {PaxConnectionType} from 'app/constant'
import terminalService from 'app/services/TerminalService'
import {FC, useEffect, useState} from 'react'
import {Spinner} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from 'setup'
import {setIsDirty, setOrderErrors} from 'app/features/orders/redux/order/refundSlice'
import {showMessage} from 'app/redux/messageSlice'
import eventPublishService from 'app/services/EventPublishService'
import {fetchOrder, selectViewOrder} from 'app/features/orders/redux/order/orderSlice'
import {ViewOrder} from 'app/features/orders/models/OrderState'
import {refundEntirePOSOrder} from 'app/features/orders/services/RefundService'
import {orderFulfillmentStatus} from 'app/features/orders/models'
import {financialStatusTypes} from 'app/utilities'
import ordersService from 'app/services/OrdersService'
import {orderActions} from 'app/constant/order'
import { defaultPaymentErrorMessage } from 'app/constant/payment'
interface Props2 {
  locationId: string
  title: string
  className?: string
  currentState: {
    sendEmail: boolean
    reason: string
  }
  onClose: () => void
}

const ElavonRefundButton: FC<Props2> = ({locationId, currentState, onClose, ...props}) => {
  const dispatch = useDispatch()
  const [terminal, setTerminal] = useState<any>(null)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [disabled, setIsDisabled] = useState(false)

  const order = useSelector<RootState, ViewOrder>(selectViewOrder)

  useEffect(() => {
    const fetch = async () => {
      const terminal = await terminalService.getUserStripeTerminal(locationId)
      setTerminal(terminal)
    }
    fetch()
  }, [])

  const handlePaxTerminalSubmit = async () => {
    try {
      setIsSubmitting(true)
      const callback = async (posOrder: any) => {
        if (window.corksy && window.corksy.paxTerminal) {
          const response = await window.corksy.paxTerminal.mfOrderReturn(posOrder)
          await handleCompleteReturn(response)
        } else {
          dispatch(
            showMessage({
              text: defaultPaymentErrorMessage(),
              variant: 'error',
            })
          )
        }
      }

      await refundEntirePOSOrder(order, callback)
    } catch (error:any) {
      console.error(error)
      dispatch(
        showMessage({
          text: defaultPaymentErrorMessage(),
          variant: 'error',
        })
      )
      setIsSubmitting(false)
    }
  }

  const handlePaymentRelaySubmit = async () => {
    try {
      setIsSubmitting(true)
      const callback = async (posOrder: any) => {
        if (window.corksy && window.corksy.paymentRelayClient) {
          await window.corksy.paymentRelayClient.mfOrderReturn(posOrder, handleCompleteReturn)
        } else {
          dispatch(
            showMessage({
              text: defaultPaymentErrorMessage(),
              variant: 'error',
            })
          )
        }
      }
      await refundEntirePOSOrder(order, callback)
    } catch (err:any) {
      console.error(err)
      dispatch(
        showMessage({
          text: defaultPaymentErrorMessage(),
          variant: 'error',
        })
      )
      setIsSubmitting(false)
    }
  }

  const handleCompleteReturn = async (paymentResponse: any) => {
    try {
      const {error} = paymentResponse
      if (error) {
        dispatch(setOrderErrors([error.message]))
        dispatch(
          showMessage({
            text: defaultPaymentErrorMessage(error?.message),
            variant: 'error',
          })
        )
        setIsDisabled(true)
      } else {
        dispatch(setIsDirty(false))
        dispatch(showMessage({text: 'Order Refund and Restocked successfully', variant: 'success'}))
        await eventPublishService.cancelOrder({id: order.id})
        await ordersService.createOrderActionHistory(
          order.id,
          {
            ...actionMessage,
            prevFinancialStatus: order.financialStatus,
            prevFulfillmentStatus: order.fulfillmentStatus,
            isEmailSended: currentState?.sendEmail,
            note: currentState?.reason,
          },
          'The Order has been Refunded and Restocked',
          currentState?.reason
        )
        dispatch(fetchOrder(order.id))
        onClose()
      }
      setIsSubmitting(false)
    } catch (err) {
      console.error(err)
      dispatch(
        showMessage({
          text: 'Error occurred while processing your request',
          variant: 'error',
        })
      )
    } finally {
      setIsSubmitting(false)
    }
  }

  if (terminal == null) {
    return (
      <div className='me-5'>
        <button id='btnSave' type='button' {...props} disabled>
          Please wait... <Spinner size='sm' />
        </button>
      </div>
    )
  }

  if (terminal.paxConnectionType === PaxConnectionType.elavon) {
    return (
      <Button
        {...props}
        id='btnSave'
        type='button'
        isSubmitting={isSubmitting}
        onClick={handlePaxTerminalSubmit}
        disabled={disabled}
      />
    )
  }

  return (
    <Button
      {...props}
      id='btnSave'
      type='button'
      isSubmitting={isSubmitting}
      onClick={handlePaymentRelaySubmit}
      disabled={disabled}
    />
  )
}

export default ElavonRefundButton

const actionMessage = {
  message: 'The Order has been Refunded and Restocked',
  currentFulfillmentStatus: orderFulfillmentStatus.restocked,
  currentFinancialStatus: financialStatusTypes.refunded,
  actionType: orderActions.refundAndRestock,
}
